module.exports = __webpack_public_path__ + "static/media/vg.b19b54ab.svg";